<template>
    <div>
        <div style="text-align: center">
            <h3>{{ form.id ? 'Edit Rekening' : 'Tambah Rekening' }}</h3>
        </div>
        <br />
        <form v-on:submit.prevent="saveAccount">
            <label for="">Nama Bank*</label>
            <input type="text" class="form-control" v-model="form.bank" placeholder="BCA / Mandiri / BNI ..." required />
            <br>
            <label for="">Nomor Rekening*</label>
            <input type="text" class="form-control" v-model="form.number" placeholder="1234567890" required />
            <br>
            <label for="">Atas Nama*</label>
            <input type="text" class="form-control" v-model="form.name" placeholder="Nama pemilik rekening" required />
            <br>
            <label for="">Status*</label>
            <select v-model="form.active" class="form-control" required>
                <option :value="1">Aktif</option>
                <option :value="0">Tidak Aktif</option>
            </select>
            <br>
            <div class="button-group d-flex pt-25">
                <button type="submit"
                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                    simpan
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: {
            defaultValue: {
                type: Object,
                required: false,
            },
        },
        data() {
            return {
                form: {
                    id: null,
                    bank: null,
                    number: null,
                    name: null,
                    active: 1,
                },
            };
        },
        watch: {
            defaultValue: {
                handler: function (val) {
                    if (val && val.id) {
                        this.form = {
                            id: val.id,
                            bank: val.bank,
                            number: val.number,
                            name: val.name,
                            active: val.active,
                        };
                    } else {
                        this.form = {
                            id: null,
                            bank: null,
                            number: null,
                            name: null,
                            active: 1,
                        };
                    }
                },
                deep: true,
                immediate: true,
            },
        },
        methods: {
            async saveAccount() {
                try {
                    let req = {
                        bank: this.form.bank,
                        number: this.form.number,
                        name: this.form.name,
                        active: parseInt(this.form.active),
                    };

                    if (this.form.id) {
                        req.id = this.form.id;
                        let response = await this.$store.dispatch('admin_bank_account_update', req);
                        this.$toast.success(response.data.message);
                    } else {
                        let response = await this.$store.dispatch('admin_bank_account_create', req);
                        this.$toast.success(response.data.message);
                    }

                    this.$root.$emit("toggle_modal", "new_bank_account");
                    this.$root.$emit("refresh_table", true);

                    this.form = {
                        id: null,
                        bank: null,
                        number: null,
                        name: null,
                        active: 1,
                    };
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || "Gagal menyimpan rekening");
                }
            }
        },
    };
</script>

<style scoped>

</style>
